import type { LogoProps } from '../logo.types';
import whiteLarge from '../../../assets/logos/logo-rd-tagline-white-large.svg';
import whiteHuge from '../../../assets/logos/logo-rd-tagline-white-huge.svg';
import whiteEnormous from '../../../assets/logos/logo-rd-tagline-white-enormous.svg';

const sizeToImage = {
  large: whiteLarge,
  huge: whiteHuge,
  enormous: whiteEnormous,
};

const TITLE = "RdSaude Tagline White Logo"

const RdSaudeTaglineWhite = ({ size, className }: LogoProps) => {
  return (
    <img
      title={TITLE}
      role='img'
      aria-labelledby={TITLE}
      src={sizeToImage[size ?? "large"]}
      alt={TITLE}
      className={className}
    />
  );
};

export default RdSaudeTaglineWhite; 